var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-bar"}},[_c('div',{staticClass:"inner"},[_c('Logo',{attrs:{"vertical":true}}),_c('div',{staticClass:"actions"},[_c('div',[_c('ProfileMenu')],1),_c('div',[_c('MenuToggle')],1)])],1),_c('div',{staticClass:"click-block",class:{open: _vm.isOpen},on:{"click":function($event){return _vm.closeMenu();}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }